import React, { FC, useEffect } from 'react';

import { CardSchema } from 'constants/graphqlTypes';
import { useIsUserAllowedToReact, useItemUrl } from 'components/Card/helpers/hooks';
import { useReactionMenu } from 'components/Reactions/helpers/hooks';
import usePageType from 'helpers/usePageType';
import useReferrerId from 'helpers/useReferrerId';
import getAuthUser from 'helpers/getAuthUser';
import ReactionMenu from 'components/Reactions/ReactionMenu';
import InteractionBlock from 'components/InteractionBlock';
import ReactionsModal from 'components/Reactions/ReactionsModal';
import { useReactionContextState } from 'components/Reactions/hooks';

import { StyledLink, StyledWrap } from './styled';
import Card from './Card';

interface IListCardProps {
  item: CardSchema;
  isReplace?: boolean;
  disableLink?: boolean;
  dataTestId?: string;
  fontColor?: string;
}

const BigCard: FC<IListCardProps> = ({ disableLink, item, isReplace, dataTestId, fontColor }) => {
  const {
    reactionCoordinates,
    setReactionCoordinates,
    isQuickReactionOpen,
    setIsQuickReactionOpen,
    isReactionsModalOpen,
    setIsReactionsModalOpen,
    infoRef,
    minusTop,
  } = useReactionMenu();

  const { thoughtId, setThoughtId, pickerId, setPickerId, cardId, setCardId } = useReactionContextState();

  const { id, isCollaborative, creators } = item;
  const isUserAllowedToReact = useIsUserAllowedToReact(creators?.items[0]?.user);
  const { isInvite, isMessages } = usePageType();

  const url = useItemUrl(id, true);
  const { userId } = getAuthUser();
  const reffererId = useReferrerId();
  const isCurrentUserList = !!creators?.items?.find((data) => data?.user?.id === userId)?.user?.id;
  const isDisableReaction =
    isCurrentUserList || isCollaborative || isInvite || isMessages || !isUserAllowedToReact || disableLink;

  useEffect(() => {
    setPickerId(creators?.items?.[0]?.user?.id ?? reffererId ?? null);
    setCardId(id);
  }, []);

  return (
    <StyledWrap
      data-testid={dataTestId}
      ref={infoRef}
      disableLinks={isQuickReactionOpen || disableLink}
      fontColor={fontColor}
    >
      <InteractionBlock
        tapCallback={() => setIsQuickReactionOpen(false)}
        getTapCoordinates={(x, y) => setReactionCoordinates({ x, y })}
        disableUserAction={disableLink}
      >
        <div>
          <StyledLink
            onClick={(e) => {
              if (disableLink) {
                e.preventDefault();
              }
            }}
            className="card collection-preview-anchor"
            replace={isReplace}
            to={url}
          >
            <Card item={item} fontColor={fontColor} />
          </StyledLink>
        </div>
      </InteractionBlock>
      {reactionCoordinates && reactionCoordinates.x && reactionCoordinates.y && !isDisableReaction && (
        <ReactionMenu
          isOpen={isQuickReactionOpen}
          anchorPoint={reactionCoordinates}
          onClose={() => setIsQuickReactionOpen(false)}
          onSend={() => {}}
          onEmoji={() => {}}
          onOpenReactionsModal={() => setIsReactionsModalOpen(true)}
        />
      )}
      {isReactionsModalOpen && <ReactionsModal id={id} handleClose={() => setIsReactionsModalOpen(false)} />}
    </StyledWrap>
  );
};

export default BigCard;
